export function initializeAxisOptions(axisType: string) {
  if (axisType === 'y') {
    return {
      position: 'left',
      onZero: true,
      showLabel: true,
      fontSize: 12,
      name: '',
      nameLocation: 'middle',
      nameGap: 15,
      nameColor: 'red',
      nameSize: '20',
      tickSizeLeft: 5,
      tickPaddingLeft: 10,
      tickRotationLeft: 0,
      tickSizeRight: 5,
      tickPaddingRight: 10,
      tickRotationRight: 0,
      measuresList: [],
      enableMin: false,
      minValue: 0,
      enableMax: false,
      maxValue: 10000,
    };
  }
  if (axisType === 'x') {
    return {
      position: 'bottom',
      onZero: true,
      showLabel: true,
      fontSize: 12,
      name: '',
      nameLocation: 'middle',
      nameGap: 15,
      nameColor: 'red',
      nameSize: '20',
      tickSizeBottom: 5,
      tickPaddingBottom: 10,
      tickRotationBottom: 0,
      tickSizeTop: 5,
      tickPaddingTop: 10,
      tickRotationTop: 0,
      measuresList: [],
      enableMin: false,
      minValue: 0,
      enableMax: false,
      maxValue: 10000,
    };
  }
}
